'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by sidchik on 05.04.17.
                                                                                                                                                                                                                                                                   */


exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var payload = action.payload;

    var actionRegExp = /^DATASOURCE_(.*)_LIST$/g;
    var successRegExp = /^DATASOURCE_(.*)_LIST_SUCCESS$/g;
    var getSuccessRegExp = /^DATASOURCE_(.*)_GET_SUCCESS$/g;
    var patchStartRegExp = /^DATASOURCE_(.*)_PATCH$/g;
    var patchSuccessRegExp = /^DATASOURCE_(.*)_PATCH_SUCCESS$/g;
    var removeStartRegExp = /^DATASOURCE_(.*)_REMOVE$/g;
    var removeSuccessRegExp = /^DATASOURCE_(.*)_REMOVE_SUCCESS$/g;

    switch (action.type) {
        case _datasource.REGISTER_DATASOURCE:
            if (!state[payload.name] || action.reset) {
                var _newState = _.clone(state);
                var initial = _.cloneDeep(initiaDataSourceState);

                // Set Initial Data
                initial.dataSource = payload;
                initial.perPage = payload.perPage;

                if (payload.sorter && Object.keys(payload.sorter).length) {
                    initial.sorter = payload.sorter;
                } else if (payload.defaultSorter) {
                    initial.sorter = {
                        columnKey: payload.defaultSorter.field,
                        field: payload.defaultSorter.field,
                        order: payload.defaultSorter.order
                    };
                }

                _newState[action.payload.name] = initial;
                return _newState;
            }
            break;
        case _datasource.PAGINATION_DATASOURCE:
            if (!state[payload.dataSource.name]) break;
            var newState = _.clone(state);
            var newDataState = _.clone(newState[payload.dataSource.name]);
            newDataState.page = payload.page;
            newDataState.perPage = payload.perPage;
            newDataState.isLoading = true;
            newState[payload.dataSource.name] = newDataState;
            return newState;
    }

    // Проверяем пошел ли новый запрос
    var match = actionRegExp.exec(action.type);
    if (match) {
        var sourceName = match[1];
        if (state[sourceName]) {
            var _newState2 = _.clone(state);

            _newState2[sourceName] = action.payload.options.newState;
            _newState2[sourceName].isLoading = true;

            return _newState2;
        }
    }

    // Проверяем пришел ли успешным ответ с dataSource
    match = successRegExp.exec(action.type);
    if (match) {
        var _sourceName = match[1];
        if (state[_sourceName]) {
            var _newState3 = _.clone(state);
            var _newDataState = _.clone(state[_sourceName]);

            Object.assign(_newDataState, _newDataState.dataSource.parseListPayload(action.payload));

            _newDataState.byId = {};
            _newDataState.pageList.forEach(function (elem) {
                return _newDataState.byId[elem.id] = elem;
            });

            _newState3[_sourceName] = _newDataState;
            _newState3[_sourceName].isLoading = false;

            return _newState3;
        }
    }

    match = getSuccessRegExp.exec(action.type);
    if (match) {
        var _sourceName2 = match[1];
        if (state[_sourceName2]) {
            var _newState4 = _.clone(state);
            var _newDataState2 = _.clone(state[_sourceName2]);

            var id = _.get(action, 'options.extra.id');
            if (id) {
                _newDataState2.byId[id] = _extends({}, action.payload.body);
            }

            _newState4[_sourceName2] = _newDataState2;

            return _newState4;
        }
    }

    // Проверяем пришел ли успешным ответ с patch
    match = patchStartRegExp.exec(action.type);
    if (match) {
        var _sourceName3 = match[1];
        if (state[_sourceName3]) {
            var _newState5 = _.clone(state);
            var _newDataState3 = _.clone(state[_sourceName3]);

            _newDataState3.isLoading = true;
            _newState5[_sourceName3] = _newDataState3;

            return _newState5;
        }
    }

    // Проверяем пришел ли успешным ответ с patch
    match = patchSuccessRegExp.exec(action.type);
    if (match) {
        var _sourceName4 = match[1];
        if (state[_sourceName4]) {
            var _newState6 = _.clone(state);
            var _newDataState4 = _.clone(state[_sourceName4]);

            var _id = _.get(action, 'options.extra.id');
            if (_id) {
                if (_newDataState4.byId[_id]) {
                    _newDataState4.byId[_id] = _extends({}, _newDataState4.byId[_id], action.payload.body);
                }
                _newDataState4.pageList = _newDataState4.pageList.map(function (t) {
                    return t.id === _id ? _extends({}, t, action.payload.body) : t;
                });
            }

            _newState6[_sourceName4] = _newDataState4;
            _newState6[_sourceName4].isLoading = false;

            return _newState6;
        }
    }

    // Проверяем пришел ли успешным ответ с remove
    match = removeStartRegExp.exec(action.type);
    if (match) {
        var _sourceName5 = match[1];
        if (state[_sourceName5]) {
            var _newState7 = _.clone(state);
            var _newDataState5 = _.clone(state[_sourceName5]);

            _newDataState5.isLoading = true;
            _newState7[_sourceName5] = _newDataState5;

            return _newState7;
        }
    }

    // Проверяем пришел ли успешным ответ с remove
    match = removeSuccessRegExp.exec(action.type);
    if (match) {
        var _sourceName6 = match[1];
        if (state[_sourceName6]) {
            var _newState8 = _.clone(state);
            var _newDataState6 = _.clone(state[_sourceName6]);

            var _id2 = _.get(action, 'options.extra.id');
            if (_id2) {
                delete _newDataState6.byId[_id2];
                var removedIndex = (0, _lodash.findIndex)(_newDataState6.pageList, function (t) {
                    return t.id === _id2;
                });
                if (removedIndex > -1) {
                    _newDataState6.pageList = [].concat(_toConsumableArray(_newDataState6.pageList.slice(0, removedIndex)), _toConsumableArray(_newDataState6.pageList.slice(removedIndex + 1)));
                }
            }

            _newState8[_sourceName6] = _newDataState6;
            _newState8[_sourceName6].isLoading = false;

            return _newState8;
        }
    }

    return state;
};

var _lodash = require('lodash');

var _datasource = require('../actions/datasource');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {};

var initiaDataSourceState = {
    pageList: [],
    byId: {},
    count: 0,
    perPage: '50',
    page: 1,
    isLoading: true,
    filters: {},
    sorter: {},
    dataSource: null,
    extra: {}
};
//# sourceMappingURL=dataSources.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/reducers/dataSources.js
// module id = 1288
// module chunks = 5